export function tryParse<T = any>(obj: string, defaultValue: T | null = null): T | null {
  try {
    const parsed = JSON.parse(obj);
    return parsed;
  } catch {
    return defaultValue;
  }
}

export function convertToTitleCase(string: string): string {
  return string.replace(/\w\S*/g, (text) => {
    return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
  });
}
